import React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { IconButton, Tooltip } from "@mui/material";
import { t } from "i18next";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { ROLE } from "../../../../../utils/constants/profiles";
import { useSelector } from "react-redux";

const CardBarChart = ({ dataWeek, downloadExcel }) => {
  const role = useSelector((state) => state.app.role);
  const giorniDellaSettimana = [
    "Lunedì",
    "Martedì",
    "Mercoledì",
    "Giovedì",
    "Venerdì",
    "Sabato",
    "Domenica",
  ];

  const datiOrdinati = giorniDellaSettimana.map((giorno) => {
    const dato = dataWeek?.find((item) => item.day === giorno);
    return dato ? dato : { day: giorno, validated: 0, pending: 0, rejected: 0 };
  });

  return (
    <div className="flex-col w-full h-full p-3 shadow-md rounded-lg">
      <div className="flex w-full justify-between p-3">
        <p className="text-2xl font-bold m-0 ">Riepilogo Settimanale</p>
        {ROLE.USER !== role && (
          <Tooltip title={t("Download")}>
            <IconButton
              className="hidden" //disabled download
              onClick={() => downloadExcel("weekly")}
            >
              <DownloadRoundedIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
      <div className=" w-full flex justify-center">
        <BarChart
          borderRadius={50}
          dataset={datiOrdinati}
          series={[
            {
              id: "validated",
              dataKey: "validated",
              label: "Controllati",
              color: "#359F1C",
            },
            {
              id: "pending",
              dataKey: "pending",
              label: "Da Controllare",
              color: "#d86f07",
            },
            {
              id: "rejected",
              dataKey: "rejected",
              label: "Scartati",
              color: "#c1272d",
            },
          ]}
          height={350}
          xAxis={[
            {
              scaleType: "band",
              id: "week",
              data: giorniDellaSettimana,
              categoryGapRatio: 0.3,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default CardBarChart;
